/**
 * DS-internal hook : `active` tient depuis `ms` au moins. Faux dès qu'il retombe, et le compte repart à zéro
 * au suivant. Pour ce qui ne doit pas clignoter sur un état bref (la connexion au live perdue,
 * `pages/StudentLivePage/liveLostNotice`). Le squelette d'une page suit la même règle à 150 ms, écrite à part
 * avec sa règle pure (`useSkeletonGate`, `utils/skeletonGate`) : pas de troisième exemplaire.
 */
import { useEffect, useState } from "react"

export function useHeldFor(active: boolean, ms: number): boolean {
    // État d'interface : le délai est passé, `active` toujours vrai.
    const [held, setHeld] = useState(false)

    useEffect(() => {
        if (!active) {
            setHeld(false)
            return undefined
        }
        const id = setTimeout(() => setHeld(true), ms)
        return () => clearTimeout(id)
    }, [active, ms])

    return active && held
}
